import { Clock3, LogOut, ShieldAlert, UserX } from "lucide-react";
import { Navigate, useParams } from "react-router-dom";
import { useAuth } from "./AuthContext";

const statusContent = {
  pending: {
    icon: Clock3,
    title: "Your light is waiting for approval.",
    message:
      "The Foundation has received your account. You’ll gain access to My Atlas after an administrator reviews it.",
  },
  rejected: {
    icon: UserX,
    title: "This account was not approved.",
    message: "Contact the Foundation if you believe this decision was made in error.",
  },
  suspended: {
    icon: ShieldAlert,
    title: "Access to this account is paused.",
    message: "Your records remain preserved. Contact the Foundation for help restoring access.",
  },
  inactive: {
    icon: Clock3,
    title: "This account is inactive.",
    message: "Contact the Foundation if you would like to return to the Guiding Stars Program.",
  },
} as const;

export function AccountStatusPage() {
  const { status } = useParams();
  const auth = useAuth();
  if (!auth.user) return <Navigate to="/sign-in" replace />;
  if (auth.profile?.status === "approved") return <Navigate to="/atlas" replace />;
  const content = statusContent[status as keyof typeof statusContent] ?? statusContent.pending;
  const Icon = content.icon;
  return (
    <section className="auth-page">
      <div className="auth-card status-card">
        <Icon size={42} strokeWidth={1.4} aria-hidden="true" />
        <p className="eyebrow">Account status</p>
        <h1>{content.title}</h1>
        <p>{content.message}</p>
        <p className="account-email">{auth.user.email}</p>
        <button className="button button-ghost" type="button" onClick={() => void auth.signOut()}>
          <LogOut size={17} /> Sign out
        </button>
      </div>
    </section>
  );
}
